import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=123efa90&scoped=true"
import script from "./mall.vue?vue&type=script&lang=js"
export * from "./mall.vue?vue&type=script&lang=js"
import style0 from "./mall.vue?vue&type=style&index=0&id=123efa90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123efa90",
  null
  
)

export default component.exports